export enum TimeLinePhase {
  PREGAME_START = 'pregame_start',
  START = 'start',
  FIRST_HALF_START = 'regular.firsthalf.start',
  FIRST_HALF_END = 'regular.firsthalf.end',
  SECOND_HALF_START = 'regular.secondhalf.start',
  SECOND_HALF_END = 'regular.secondhalf.end',
  OT_FIRST_HALF_START = 'overtime.firsthalf.start',
  OT_FIRST_HALF_END = 'overtime.firsthalf.end',
  OT_SECOND_HALF_START = 'overtime.secondhalf.start',
  OT_SECOND_HALF_END = 'overtime.secondhalf.end',
  PENALTY_SHOOTOUT = 'penalty',
  END = 'end',
  NOW = 'now'
}

export const TimeLinePhases = [
  'pregame_start',
  'start',
  'regular.firsthalf.start',
  'regular.firsthalf.end',
  'regular.secondhalf.start',
  'regular.secondhalf.end',
  'overtime.firsthalf.start',
  'overtime.firsthalf.end',
  'overtime.secondhalf.start',
  'overtime.secondhalf.end',
  'overtime.shootout',
  'overtime.shootout.start',
  'overtime.shootout.end',
  'end',
  'now'
];
